import React from 'react';
import { Redirect } from 'react-router-dom';
import { getBaseUrl } from './utils';
import './App.scss';

const baseUrl = getBaseUrl();

class ConfirmSubscription extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      token: null,
      isConfirmed: false,
      redirect: false
    }
  }

  componentDidMount() {
    const { token } = this.props.match.params;

    this.setState({ token }, () => {
      this.confirmSusbcription();
    });
  }

  confirmSusbcription = () => {
    fetch(`${baseUrl}/v1/confirm-subscription?token=${this.state.token}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      credentials: 'include'
      })
      .then(response => response.json())
      .then((response) => {
        this.setState({ isConfirmed: true, redirect: true });
      });
  }

  renderRedirect = () => {
    const { pathname } = this.props.location;
    let pathnameDestination = '/';
    if (pathname.includes('/public/')) {
      pathnameDestination = pathname.split('/confirm/')[0];
    }
    if (this.state.redirect) {
      return <Redirect to={{
        pathname: pathnameDestination,
        search: '?confirm=true'
      }} />
    }
  }

  render() {
    return(
      <div className="container">
        {this.renderRedirect()}
        {!this.isConfirmed && <span>Confirming your subscription</span>}
      </div>
    );
  }
}

export default ConfirmSubscription;
